import "babel-polyfill";
import Vue from 'vue';
import axios from 'axios';
import cookies from 'js-cookie';
import EventHandler from './core/VueEventHandler';
import AOS from 'aos';

window.EventHandler = new EventHandler;
window.AOS = AOS;
window.Cookies = cookies;
Vue.prototype.$http = window.axios = axios;

Vue.component('navigation-handler', require('./components/Navigation/NavigationHandler.vue'));
Vue.component('drop-down-wrapper', require('./components/Navigation/DropDownWrapper.vue'));
Vue.component('navigation', require('./components/Navigation/Navigation.vue'));

Vue.component('cookie-consent', require('./components/Cookie/CookieConsent.vue'));
Vue.component('cookie-setup', require('./components/Cookie/CookieSetup.vue'));
Vue.component('share-buttons', require('./components/ShareButtons.vue'));
Vue.component('captcha', require('./../src/components/Captcha.vue'));

import Form from './core/Form';
import Slider from './core/Slider';
import Header from './core/Header';
import Gallery from './core/Gallery';
import AnimateOnScroll from './core/AnimateOnScroll';

new Vue({
    el: '#app',
    mounted() {
        document.body.addEventListener('click', event => window.EventHandler.fire('body-clicked', event));
        new Form();
        new Slider();
        new Header();
        new Gallery();
        new AnimateOnScroll();
    }
});



// WEBPACK FOOTER //
// ./resources/js/src/app.js